import { UserRole } from "services/api/users/types";
import { PaginationDirection } from "services/url";
import { Pagination } from "services/search/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import Badge from "ui/components/Badge/Badge";
import { ReactSVG } from "react-svg";

export const initialRecipientsPagination: Pagination = {
  pageNumber: 1,
  pageSize: 20,
  sort: { sortBy: "firstName", direction: PaginationDirection.Ascending },
};

export const getRecipientColumns = (
  channels: number,
  onEditUser: (userId: string) => void
): Column[] => {
  const columns: Column[] = [
    {
      title: "Ime i prezime",
      field: "firstName",
      type: ColumnTypes.custom,
      sortable: true,
      render: (row: any) => (
        <span className="text-sm font-medium text-slate-900">
          {row.firstName} {row.lastName}
        </span>
      ),
    },
    {
      title: "Role",
      type: ColumnTypes.custom,
      render: (row: any) => (
        <div className="flex flex-wrap gap-1">
          {row.roles?.map((r: UserRole) => (
            <Badge key={r.id} text={r.name} variant="info" height="small" />
          ))}
        </div>
      ),
    },
  ];

  // Email column — only if Email channel selected (channels & 1)
  if (channels & 1) {
    columns.push({
      title: "Email",
      field: "email",
      type: ColumnTypes.string,
    });
  }

  // Mobile phone column — only if SMS channel selected (channels & 2)
  if (channels & 2) {
    columns.push({
      title: "Mobitel",
      field: "mobilePhoneNumber",
      type: ColumnTypes.string,
    });
  }

  // Edit column
  columns.push({
    title: "",
    type: ColumnTypes.custom,
    render: (row: any) => (
      <button
        type="button"
        className="p-1 hover:bg-slate-100 rounded"
        onClick={(e) => {
          e.stopPropagation();
          onEditUser(row.id);
        }}
      >
        <ReactSVG src="/media/icons/edit.svg" className="w-4 h-4" />
      </button>
    ),
  });

  return columns;
};
